import axios from 'axios';
import BusinessRulesStorage from 'components/business-rules/BusinessRulesStorage';

const CustomBusinessRulesService = {
  getAllChannels() {
    const url = `${process.env.REACT_APP_HOST_URL}Channel/GetAllChannels`;
    return axios.get(url);
  },

  getAllBusinessRulesChannel(channelId) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/GetAllBusinessRulesChannel/${channelId}`;
    return axios.get(url);
  },

  getAllBusinessRulesOrganisation(organisationId) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/GetAllBusinessRulesOrganisation/${organisationId}`;
    return axios.get(url);
  },

  getCustomBusinessRules(channelId) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/GetBusinessRulesChannel/${channelId}`;
    return axios.get(url);
  },

  getAllBusinessRulesValues(organisationId) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/GetAllBusinessRulesValues/${organisationId}`;
    return axios.get(url);
  },

  getCustomBusinessRulesOrganisation(organisationId) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/GetBusinessRulesOrganisation/${organisationId}`;
    return axios.get(url);
  },

  editCustomBusinessRule(id, channelId, json) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/EditBusinessRuleChannel/${id}?channelId=${channelId}`;
    return axios.put(url, json);
  },

  editCustomBusinessRuleOrganisation(id, organisationId, json) {
    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/EditBusinessRuleOrganisation/${id}?organisationId=${organisationId}`;
    return axios.put(url, json);
  },

  getChannelsByOrganisation(organisationId) {
    const url = `${process.env.REACT_APP_HOST_URL}Channel/OrganisationChannelLookup?organisationId=${organisationId}`;
    return axios.get(url);
  },

  importCustomBusinessRules(organisationId, file) {
    const formData = new FormData();

    formData.append('file', file);

    let queryParams = `organisationId=${organisationId}`;

    const url = `${process.env.REACT_APP_HOST_URL}BusinessRule/ImportCustom?${queryParams}`;

    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default CustomBusinessRulesService;
